export default class DropdownViewModel {
    id: number | string = '';
    value: string = '';
    disabled?: boolean | undefined = undefined;
}
